import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import classNames from 'classnames';
import React, { useState, useEffect } from 'react';
import { Divider, Category, AnimatedContainer, Button, ANIMATION_TYPES } from '@mirohq-internal/website-ui-foundation';
import { UserStatus } from '@mirohq-internal/website-utils';
import { MenuItem } from './menu-item.esm.js';

const getAnimationType = (animated, isFirstLevel)=>{
    if (isFirstLevel && animated) {
        return ANIMATION_TYPES.NONE;
    }
    return isFirstLevel ? ANIMATION_TYPES.FADE_IN : ANIMATION_TYPES.SLIDE_IN_FADE_IN;
};
const DrawerMenu = ({ contactSalesLink, dashboardLink, loginLink, menu, setCurrentMenuPath, currentMenuPath, signupLink, userStatus })=>{
    const [animated, setAnimated] = useState(false);
    const isFirstLevel = currentMenuPath.length === 0;
    const animationType = getAnimationType(animated, isFirstLevel);
    let animationDelay = 0;
    const isLoggedIn = userStatus === UserStatus.loggedIn;
    useEffect(()=>{
        setTimeout(()=>{
            /**
             * Once the drawer has been opened, we need to set this to true to prevent
             * the animation from running again unless the drawer has been closed
             */ setAnimated(true);
        }, 500);
    }, []);
    return jsxs("div", {
        className: "drawer-menu d-flex flex-column h-100 justify-content-between",
        children: [
            jsxs("ul", {
                className: "p-0 list-unstyled d-flex flex-column gap-300",
                children: [
                    menu?.children?.map((node, nodeIndex)=>{
                        if (isFirstLevel && node?.children) {
                            return jsx(MenuItem, {
                                animationDelay: animationDelay++,
                                animationType: animationType,
                                href: node?.href,
                                label: node.label,
                                media: node?.media,
                                onSelect: ()=>{
                                    setCurrentMenuPath([
                                        ...currentMenuPath,
                                        nodeIndex
                                    ]);
                                }
                            }, node.label);
                        }
                        if (node?.children) {
                            return jsxs(React.Fragment, {
                                children: [
                                    !!nodeIndex && jsx(Divider, {
                                        className: "my-100",
                                        light: true
                                    }),
                                    jsx(Category, {
                                        animationDelay: animationDelay++,
                                        animationType: animationType,
                                        className: "mb-n50",
                                        children: node.label
                                    }),
                                    node?.children?.map((child, childIndex)=>jsx(MenuItem, {
                                            animationDelay: animationDelay++,
                                            animationType: animationType,
                                            href: child?.href,
                                            label: child.label,
                                            media: child?.media,
                                            onSelect: ()=>{
                                                setCurrentMenuPath([
                                                    ...currentMenuPath,
                                                    childIndex
                                                ]);
                                            }
                                        }, child.label))
                                ]
                            }, node.label);
                        }
                        return jsx(MenuItem, {
                            animationDelay: animationDelay++,
                            animationType: animationType,
                            href: node.href,
                            label: node.label
                        }, node.label);
                    }),
                    isFirstLevel && contactSalesLink && jsxs(Fragment, {
                        children: [
                            jsx(Divider, {
                                animationDelay: animationDelay++,
                                animationType: animationType,
                                className: "my-100",
                                light: true
                            }),
                            jsx(MenuItem, {
                                animationDelay: animationDelay++,
                                animationType: animationType,
                                href: contactSalesLink?.href,
                                label: contactSalesLink?.label
                            }, contactSalesLink.label)
                        ]
                    }),
                    jsx(Divider, {
                        animationDelay: animationDelay++,
                        animationType: animationType,
                        className: "my-100",
                        light: true
                    })
                ]
            }),
            isFirstLevel && jsxs("div", {
                className: classNames('d-flex text-center flex-column gap-100'),
                children: [
                    !isLoggedIn && loginLink && jsx(AnimatedContainer, {
                        className: "d-flex flex-column",
                        delay: animationDelay++,
                        animationType: animationType,
                        children: jsx(Button.Outline, {
                            href: loginLink?.href,
                            withStroke: true,
                            children: loginLink?.label
                        })
                    }),
                    !isLoggedIn && signupLink && jsx(AnimatedContainer, {
                        className: "d-flex flex-column",
                        delay: animationDelay++,
                        animationType: animationType,
                        children: jsx(Button.Primary, {
                            href: signupLink?.href,
                            withStroke: true,
                            children: signupLink?.label
                        })
                    }),
                    isLoggedIn && dashboardLink && jsx(AnimatedContainer, {
                        className: "d-flex flex-column",
                        delay: animationDelay++,
                        animationType: animationType,
                        children: jsx(Button.Primary, {
                            href: dashboardLink?.href,
                            withStroke: true,
                            children: dashboardLink?.label
                        })
                    })
                ]
            })
        ]
    });
};

export { DrawerMenu };
